import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { Button, Modal } from 'antd';
import "./Users.less";

import DataTable from 'src/components/common/DataTable';
import ExcelRowValidationResultDTO from 'src/models/validation/ExcelRowValidationResultDTO';

export interface UsersUploadErrorModalProps extends LocalizeContextProps {
    errorMessage: string;
    tableData: ExcelRowValidationResultDTO[];
    fileName: string;
    visible: boolean;

    onOkay: () => void;
}

interface UsersUploadErrorModalState {
}

class UsersUploadErrorModal extends React.Component<UsersUploadErrorModalProps, UsersUploadErrorModalState> {
    private dataTableRef: DataTable<ExcelRowValidationResultDTO>;

    constructor(props: UsersUploadErrorModalProps) {
        super(props);
        bindAllOfThis(this, UsersUploadErrorModal.prototype);

        this.state = {
        };
    }

    componentDidUpdate(prevProps: UsersUploadErrorModalProps, prevState: UsersUploadErrorModalState) {
        // Force update if we are going to be visible
        if (!prevProps.visible && this.props.visible) {
            this.dataTableRef && this.dataTableRef.refresh();
        }
    }

    private handleOkayClick() {
        this.props.onOkay && this.props.onOkay();
    }

    private handleCancelClick() {
        // Dev Note: (11/15/20) removed onCancel since it doesn't make sense
        this.props.onOkay && this.props.onOkay();
    }

    private renderValidationMessage() {
        if (this.props.errorMessage == null || this.props.errorMessage.length < 1) {
            return null;
        }
        let messages = this.props.errorMessage.split('\n')
            .map<React.ReactNode>(t => <span key={t}>{t}</span>)
            .reduce((prev, curr) => [prev, <br />, curr]);
        return <p>{messages}</p>;
    }

    private renderStudentsDataTable() {
        if (this.props.tableData == null || this.props.tableData.length < 1) {
            return null;
        }

        return (
            <React.Fragment>
                <h3>Student Errors</h3>
                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={false}
                    tableProps={{ rowKey: 'rowNumber' }}
                    data={this.props.tableData}
                    columns={[
                        DataTable.AdvancedColumns.Text<ExcelRowValidationResultDTO>('Row Number', 'rowNumber', 150),
                        DataTable.AdvancedColumns.Custom<ExcelRowValidationResultDTO>('Error', 'errorMessages', undefined, record => {
                            if (record.errorMessages.length === 0) {
                                return null;
                            }

                            return record.errorMessages
                                .map<React.ReactNode>(t => <span key={t}>{t}</span>)
                                .reduce((prev, curr) => [prev, <br />, curr]);
                        })
                    ]}
                />
            </React.Fragment>
        );
    }

    render() {
        return (
            <Modal
                maskClosable={false}
                width={900}
                centered={true}
                visible={this.props.visible}
                onCancel={this.handleCancelClick}
                title={`File Validation Errors`}

                footer={[
                    <Button type="primary" key="okay" onClick={this.handleOkayClick}><Translate id="common.ok" /></Button>
                ]}
            >
                <h3>File Name</h3>
                <p>{this.props.fileName}</p>
                <h3>File Validation Error</h3>
                {this.renderValidationMessage()}
                {this.renderStudentsDataTable()}
            </Modal>
        );
    }
}


export default withLocalize(UsersUploadErrorModal);



// WEBPACK FOOTER //
// ./src/pages/admin/UsersUploadErrorModal.tsx